import { render } from "./scrollspy-navitem.vue?vue&type=template&id=29f2ceca"
import script from "./scrollspy-navitem.vue?vue&type=script&lang=js"
export * from "./scrollspy-navitem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__